// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_SwxP8EfL","container":"_x9p3tOx2","text":"_mxxCU_GK","dropdownWrapper":"_uIKwzAfo"};